import QuestionAnswers from './questionAnswers'

export { QuestionAnswers }
